import { I18nService } from "@perxis-auto/shared";
import { APP } from "../../../shared/config/app.js";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import { sortEquipmentGroupsMap } from "./sortEquipmentGroupsMap.js";
function formatSpecifications(data, options = { onlyDifferences: false }) {
  const { i18n } = I18nService.getInstance();
  const { specificationValuesMatrix, specificationsMap, specificationGroupsMap } = data;
  const { onlyDifferences = false } = options;
  const equipmentGroupsMap = {};
  const allComparedSpecificationIds = Array.from(
    new Set(specificationValuesMatrix.flat().map((specValue) => specValue.specification))
  );
  for (const specificationId of allComparedSpecificationIds) {
    const specification = specificationsMap[specificationId];
    if (!specification) {
      continue;
    }
    const specificationGroup = specificationGroupsMap[specification.data.group || ""];
    if (!specificationGroup) {
      continue;
    }
    if (!equipmentGroupsMap[specificationGroup.id]) {
      equipmentGroupsMap[specificationGroup.id] = {
        id: specificationGroup.id,
        title: specificationGroup.data.alternateName ?? specificationGroup.data.name,
        items: [],
        position: specificationGroup.data.position
      };
    }
    const items = [];
    for (let comparedIndex = 0; comparedIndex < specificationValuesMatrix.length; comparedIndex++) {
      const comparedOptionValues = specificationValuesMatrix[comparedIndex];
      const specificationValue = comparedOptionValues.find((value2) => value2.specification === specificationId);
      const value = (specificationValue == null ? void 0 : specificationValue.stringValue) ?? (specificationValue == null ? void 0 : specificationValue.numberValue) ?? (specificationValue == null ? void 0 : specificationValue.booleanValue);
      if (!specificationValue || typeof value === "undefined") {
        items[comparedIndex] = null;
      } else {
        const formattedValue = typeof value === "boolean" ? i18n.t(`common.booleanValues.${value}Value`, { ns: APP.name }) : `${value}`;
        items[comparedIndex] = {
          id: specificationValue.id,
          label: specification.data.alternateName ?? specification.data.name,
          value,
          formattedValue,
          position: specification.data.position
        };
      }
    }
    if (!items.length || !items.some((item) => item)) {
      continue;
    }
    const itemValues = items.map((item) => item == null ? void 0 : item.value);
    if (onlyDifferences && specificationValuesMatrix.length > 1 && (/* @__PURE__ */ new Set([...itemValues])).size < 2) {
      continue;
    }
    equipmentGroupsMap[specificationGroup.id].items.push(items);
  }
  return sortEquipmentGroupsMap(equipmentGroupsMap);
}
export {
  formatSpecifications
};
